import { createContext, useContext } from 'react'
import { usePromotions, UsePromotionsReturn } from './usePromotions'

const PromotionsContext = createContext<UsePromotionsReturn | undefined>(
    undefined,
)

export const PromotionsProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const value = usePromotions()

    return (
        <PromotionsContext.Provider value={value}>
            {children}
        </PromotionsContext.Provider>
    )
}

export const usePromotionsContext = (): UsePromotionsReturn => {
    const context = useContext(PromotionsContext)
    if (context === undefined) {
        throw new Error(
            'usePromotionsContext must be used within a PromotionsProvider',
        )
    }
    return context
}
